import styled from 'styled-components';
import theme from '../../../../styles/theme';
import NaviText from '../../common/NaviText';
import Button from '../../../common/Button';
import { useCallback, useEffect, useState } from 'react';
import { useGetClientList, useGetCodeList, useGetUserList } from '../../../../interface/common';
import { FormControl, Select, InputLabel, TextField, MenuItem, FormControlLabel, RadioGroup, Radio, FormLabel, Autocomplete } from '@mui/material';
import { useSetInout } from '../../../../interface/inout';
import { useQuery } from 'react-query';
import { ErrorMsg, Row } from '../../../../styles/common';
import { IOT_TP } from '../../../common/constants';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        // display: flex;
        // align-items: center;//stretch;
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
        // background: ${theme.color.black[40]};
        // border: 1px solid red;
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }
    // .close {
    //     position: absolute;
    //     top: 0px;
    //     right: 0;
    // }
`;




const InoutItem = ({target : pTarget, onClose}) => {

    const [target, setTarget] = useState(pTarget? pTarget : {});
    const [errorMsg, setErrorMsg] = useState();

    const [clientList, setClientList] = useState([]);
    const [uList, setUList] = useState([]);

    const { data : user } = useQuery('ADMIN_USER_INFO', {});
    const { data : iotTpList} = useGetCodeList('iot_tp');
    const { data : subTpList} = useGetCodeList('sub_tp');
    const { data : cList} = useGetClientList();
    const {data : userList} = useGetUserList();
    const { mutate, error } = useSetInout();

    const handleValueChange = (id, val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleRegClick = useCallback((param) => {
        param['mode'] = 'POST';
        param['reg_id'] = user.uid;
        mutate(
            param,
            {
                onSuccess:()=>{
                    onClose(false);
                },
                onError:(e)=>{
                    // setToggle(true);
                    setErrorMsg('등록에 실패하였습니다.'+e);
                }
            }
            );
    },[mutate]);

    const handleModClick = useCallback((param) => {
        mutate(
            {...param,mode:'PUT'},
            {
                onSuccess:()=>{
                    onClose(false);
                },
                onError:(e)=>{
                    // setToggle(true);
                    setErrorMsg('수정 실패하였습니다.',e);
                }
            }
        );
    },[mutate]);

    const handleDelClick = useCallback(() => {
        const delParam = {
            mode: 'DELETE',
            sno: pTarget.sno
        }
        mutate(delParam);
    },[mutate]);

    useEffect(()=>{
        if(cList){
            setClientList(cList.map((item,index)=>({
                ...item,
                label:item.cnm})
                ));
        }
    },[cList])

    useEffect(()=>{
        if(userList){
            setUList(userList.map((item,index)=>({
                ...item,
                label:item.user_nm})
                ));
        }
    },[userList])

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'반출입'},{text:'반출입 상세'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div style={{
                    flexGrow:1,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start'
                }}
            >
                <Row style={{marginTop:'8px'}}>
                    <TextField
                        id='iot_nm'
                        label='과업명'
                        size='small'
                        value={target.iot_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='iotTp-label'>반출입유형</InputLabel>
                        <Select label="반출입유형" labelId='iotTp-label' size='small' value={target.iot_tp}>
                            <MenuItem value={''} onClick={()=>handleValueChange('iot_tp','')} >없음</MenuItem>
                            {iotTpList && iotTpList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('iot_tp',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    {target.iot_tp === IOT_TP.SEARCH &&
                        <FormControl style={{width:'12rem'}} size='small'>
                            <InputLabel id='subTp-label'>유형</InputLabel>
                            <Select label="유형" labelId='subTp-label' size='small' value={target.sub_tp}>
                                {subTpList && subTpList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('sub_tp',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        }
                    <Autocomplete
                        id="cid"
                        size='small'
                        options={clientList}
                        sx={{ width: 300 }}
                        defaultValue={target && target.cid}
                        renderInput={(params) => <TextField {...params} label="거래처" />}
                        onChange={(e,v)=>v!==null&&handleValueChange('cid',v.cid)}
                        />
                    <Autocomplete
                        id="work_id"
                        size='small'
                        options={uList}
                        sx={{ width: 120 }}
                        defaultValue={target && target.work_id}
                        renderInput={(params) => <TextField {...params} label="작업자" />}
                        onChange={(e,v)=>v!==null&&handleValueChange('work_id',v.uid)}
                        />
                </Row>
                <Row>
                    <TextField 
                        id='contents' 
                        label='조사내용' 
                        fullWidth 
                        multiline 
                        rows={6} 
                        size='small' 
                        value={target.contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr' 
                        label='비고' 
                        fullWidth 
                        multiline 
                        rows={6} 
                        size='small' 
                        value={target.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
            </div>
            <div>
                <Row>
                    {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
                </Row>
            </div>
            {(pTarget && pTarget.sno) ?
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                    <Button onClick={()=>handleModClick(target)}>수정</Button>
                    <Button onClick={handleDelClick}>삭제</Button>
                </div>
            :
                <div>
                    <Button onClick={()=>handleRegClick(target)}>등록</Button>
                </div>
            }
        </MainWrap>
    )

} 

export default InoutItem;